const firebaseConfig = {
  apiKey: "AIzaSyBA6LgI8NslQq0cZHEjdS14_RFvVYFMJrk",
  authDomain: "pawfyquiz.firebaseapp.com",
  projectId: "pawfyquiz",
  storageBucket: "pawfyquiz.appspot.com",
  messagingSenderId: "607913741774",
  appId: "1:607913741774:web:58ae52e98707f9b334af9f",
  measurementId: "G-G7KGR9B436",
};

const app = firebase.initializeApp(firebaseConfig);
firebase.firestore().settings({
  cacheSizeBytes: firebase.firestore.CACHE_SIZE_UNLIMITED,
  experimentalForceLongPolling: true,
});

firebase
  .firestore()
  .enablePersistence()
  .catch((err) => {
    if (err.code == "failed-precondition") {
      console.log(err.code);
      // Multiple tabs open, persistence can only be enabled
      // in one tab at a a time.
      // ...
    } else if (err.code == "unimplemented") {
      console.log(err.code);
      // The current browser does not support all of the
      // features required to enable persistence
      // ...
    }
  });

var Grades = {
  probiotic: 0,
  skinCoat: 0,
  hipJoint: 0,
  calming: 0,
  painRelief: 0,
  eyeSupport: 0,
  multivitamin: 0,
  analGlands: 0,
  allergyImmune: 0,
};
var Handles = {
  probiotic: "probiotic",
  skinCoat: "skin-coat",
  hipJoint: "hip-and-joint",
  calming: "calming",
  painRelief: "pain-relief",
  eyeSupport: "eye-support",
  multivitamin: "multivitamin",
  analGlands: "anal-glands",
  allergyImmune: "allergy-immune",
};
var Symptoms = {
  jointStiffness: { probiotic: 0, skinCoat: 0, hipJoint: 2, calming: 0, painRelief: 1, eyeSupport: 0, multivitamin: 0, analGlands: 0, allergyImmune: 0 },
  arthritis: { probiotic: 0, skinCoat: 0, hipJoint: 2, calming: 0, painRelief: 1, eyeSupport: 0, multivitamin: 0, analGlands: 0, allergyImmune: 0 },
  jointWear: { probiotic: 0, skinCoat: 0, hipJoint: 2, calming: 0, painRelief: 1, eyeSupport: 0, multivitamin: 0, analGlands: 0, allergyImmune: 0 },
  limping: { probiotic: 0, skinCoat: 0, hipJoint: 2, calming: 0, painRelief: 1, eyeSupport: 0, multivitamin: 0, analGlands: 0, allergyImmune: 0 },
  postSurgeryPain: { probiotic: 0, skinCoat: 0, hipJoint: 1, calming: 0, painRelief: 2, eyeSupport: 0, multivitamin: 0, analGlands: 0, allergyImmune: 0 },
  constipation: { probiotic: 2, skinCoat: 0, hipJoint: 0, calming: 0, painRelief: 0, eyeSupport: 0, multivitamin: 0, analGlands: 0, allergyImmune: 0 },
  diarrhea: { probiotic: 2, skinCoat: 0, hipJoint: 0, calming: 0, painRelief: 0, eyeSupport: 0, multivitamin: 0, analGlands: 0, allergyImmune: 0 },
  cramps: { probiotic: 2, skinCoat: 0, hipJoint: 0, calming: 0, painRelief: 0, eyeSupport: 0, multivitamin: 2, analGlands: 0, allergyImmune: 0 },
  bloating: { probiotic: 2, skinCoat: 0, hipJoint: 0, calming: 0, painRelief: 0, eyeSupport: 0, multivitamin: 0, analGlands: 0, allergyImmune: 0 },
  upsetStomach: { probiotic: 2, skinCoat: 0, hipJoint: 0, calming: 0, painRelief: 0, eyeSupport: 0, multivitamin: 0, analGlands: 0, allergyImmune: 0 },
  worms: { probiotic: 1, skinCoat: 0, hipJoint: 0, calming: 0, painRelief: 0, eyeSupport: 0, multivitamin: 0, analGlands: 0, allergyImmune: 0 },
  parasites: { probiotic: 2, skinCoat: 0, hipJoint: 0, calming: 0, painRelief: 0, eyeSupport: 0, multivitamin: 0, analGlands: 0, allergyImmune: 0 },
  weakImmunity: { probiotic: 2, skinCoat: 0, hipJoint: 0, calming: 0, painRelief: 0, eyeSupport: 0, multivitamin: 2, analGlands: 0, allergyImmune: 0 },
  lowEnergy: { probiotic: 1, skinCoat: 0, hipJoint: 0, calming: 0, painRelief: 0, eyeSupport: 0, multivitamin: 0, analGlands: 0, allergyImmune: 0 },
  repeatInfections: { probiotic: 2, skinCoat: 0, hipJoint: 0, calming: 0, painRelief: 0, eyeSupport: 0, multivitamin: 2, analGlands: 0, allergyImmune: 0 },
  itching: { probiotic: 1, skinCoat: 2, hipJoint: 0, calming: 0, painRelief: 0, eyeSupport: 0, multivitamin: 0, analGlands: 0, allergyImmune: 0 },
  poorFlexibility: { probiotic: 0, skinCoat: 0, hipJoint: 2, calming: 0, painRelief: 0, eyeSupport: 0, multivitamin: 0, analGlands: 0, allergyImmune: 0 },
  proneToInjury: { probiotic: 0, skinCoat: 0, hipJoint: 2, calming: 0, painRelief: 0, eyeSupport: 0, multivitamin: 2, analGlands: 0, allergyImmune: 0 },
  difficultyRunning: { probiotic: 0, skinCoat: 0, hipJoint: 2, calming: 0, painRelief: 0, eyeSupport: 0, multivitamin: 1, analGlands: 0, allergyImmune: 0 },
  stress: { probiotic: 0, skinCoat: 0, hipJoint: 0, calming: 2, painRelief: 0, eyeSupport: 0, multivitamin: 0, analGlands: 0, allergyImmune: 0 },
  anger: { probiotic: 0, skinCoat: 0, hipJoint: 0, calming: 2, painRelief: 0, eyeSupport: 0, multivitamin: 0, analGlands: 0, allergyImmune: 0 },
  anxiety: { probiotic: 0, skinCoat: 0, hipJoint: 0, calming: 2, painRelief: 0, eyeSupport: 0, multivitamin: 1, analGlands: 0, allergyImmune: 0 },
  tenseMuscles: { probiotic: 0, skinCoat: 0, hipJoint: 1, calming: 2, painRelief: 0, eyeSupport: 0, multivitamin: 0, analGlands: 0, allergyImmune: 0 },
  behaviouralProblems: { probiotic: 0, skinCoat: 0, hipJoint: 0, calming: 2, painRelief: 0, eyeSupport: 0, multivitamin: 0, analGlands: 0, allergyImmune: 0 },
  seasonalAllergies: { probiotic: 2, skinCoat: 2, hipJoint: 0, calming: 0, painRelief: 0, eyeSupport: 0, multivitamin: 0, analGlands: 0, allergyImmune: 2 },
  pawBiting: { probiotic: 2, skinCoat: 0, hipJoint: 0, calming: 0, painRelief: 0, eyeSupport: 0, multivitamin: 0, analGlands: 0, allergyImmune: 1 },
  excessiveLicking: { probiotic: 2, skinCoat: 1, hipJoint: 0, calming: 0, painRelief: 0, eyeSupport: 0, multivitamin: 0, analGlands: 0, allergyImmune: 2 },
  hairLoss: { probiotic: 0, skinCoat: 2, hipJoint: 0, calming: 0, painRelief: 0, eyeSupport: 0, multivitamin: 0, analGlands: 0, allergyImmune: 0 },
  hotSpots: { probiotic: 0, skinCoat: 2, hipJoint: 0, calming: 0, painRelief: 0, eyeSupport: 0, multivitamin: 0, analGlands: 0, allergyImmune: 0 },
  scabs: { probiotic: 0, skinCoat: 2, hipJoint: 0, calming: 0, painRelief: 0, eyeSupport: 0, multivitamin: 0, analGlands: 0, allergyImmune: 0 },
  bacterialInfection: { probiotic: 1, skinCoat: 2, hipJoint: 0, calming: 0, painRelief: 0, eyeSupport: 0, multivitamin: 0, analGlands: 0, allergyImmune: 0 },
  tearStains: { probiotic: 1, skinCoat: 0, hipJoint: 0, calming: 0, painRelief: 0, eyeSupport: 2, multivitamin: 0, analGlands: 0, allergyImmune: 0 },
  cataracts: { probiotic: 0, skinCoat: 0, hipJoint: 0, calming: 0, painRelief: 0, eyeSupport: 2, multivitamin: 1, analGlands: 0, allergyImmune: 0 },
  excessiveTearing: { probiotic: 0, skinCoat: 0, hipJoint: 0, calming: 0, painRelief: 0, eyeSupport: 2, multivitamin: 0, analGlands: 0, allergyImmune: 0 },
  visionLoss: { probiotic: 0, skinCoat: 0, hipJoint: 0, calming: 0, painRelief: 0, eyeSupport: 2, multivitamin: 0, analGlands: 0, allergyImmune: 0 },
  nightSight: { probiotic: 0, skinCoat: 0, hipJoint: 0, calming: 0, painRelief: 0, eyeSupport: 2, multivitamin: 0, analGlands: 0, allergyImmune: 0 },
  sleeplessness: { probiotic: 0, skinCoat: 0, hipJoint: 0, calming: 2, painRelief: 0, eyeSupport: 0, multivitamin: 0, analGlands: 0, allergyImmune: 0 },
  pain: { probiotic: 0, skinCoat: 0, hipJoint: 0, calming: 0, painRelief: 2, eyeSupport: 0, multivitamin: 0, analGlands: 0, allergyImmune: 0 },
  poorAgility: { probiotic: 0, skinCoat: 0, hipJoint: 2, calming: 0, painRelief: 0, eyeSupport: 0, multivitamin: 1, analGlands: 0, allergyImmune: 0 },
};

var Improvements = {
  hips: ["jointStiffness", "arthritis", "jointWear", "limping", "postSurgeryPain"],
  gut: ["constipation", "diarrhea", "cramps", "bloating", "upsetStomach", "worms", "parasites"],
  immunity: ["weakImmunity", "lowEnergy", "repeatInfections", "pawBiting"],
  flexibility: ["poorFlexibility", "proneToInjury", "difficultyRunning"],
  anxietyIssues: ["stress", "anger", "anxiety", "tenseMuscles", "behaviouralProblems"],
  allergy: ["seasonalAllergies", "pawBiting", "excessiveLicking"],
  coat: ["hairLoss", "hotSpots", "scabs", "itching", "bacterialInfection"],
  vision: ["tearStains", "cataracts", "excessiveTearing", "visionLoss", "nightSight"],
  inflammation: ["sleeplessness", "pain", "poorAgility"],
};

var ingSlide = null;

var PawfyQuiz = {
  nonValuesSet: false,
  initIngredientsSlider: function (productBox) {
    if (productBox.querySelector("#ingredients-slider")) {
      var productName = productBox.classList[1];
      new Splide("." + productName + " #ingredients-slider", {
        type: "loop",
        gap: window.innerWidth <= 768 ? 0 : 36,
        speed: 700,
        perPage: 1,
        easing: "cubic-bezier(0.55, 0.24, 0.52, 1.0)",
        autoplay: false,
        interval: 600000,
        focus: "center",
        pagination: false,
        padding: window.innerWidth <= 768 ? 0 : 36,
        updateOnMove: false,
        pagination: false,
        arrows: true,
        dots: false,
        arrowPath:
          "M1 4.65684C0.668629 4.65684 0.4 4.92547 0.4 5.25684C0.4 5.58821 0.668629 5.85684 1 5.85684V4.65684ZM28.4243 5.6811C28.6586 5.44679 28.6586 5.06689 28.4243 4.83257L24.6059 1.01419C24.3716 0.779881 23.9917 0.779881 23.7574 1.01419C23.523 1.24851 23.523 1.62841 23.7574 1.86272L27.1515 5.25684L23.7574 8.65095C23.523 8.88526 23.523 9.26516 23.7574 9.49948C23.9917 9.73379 24.3716 9.73379 24.6059 9.49948L28.4243 5.6811ZM1 5.85684H28V4.65684H1V5.85684Z",
      }).mount();
    }
  },
  initDirtyInputs: function () {
    var visibleInputs = document.querySelectorAll(".main__panel[style*='block'] input:not([name*='type'])");

    visibleInputs.forEach((visibleInput) => {
      ["blur", "change", "keyup", "mouseup"].forEach((ev) => {
        visibleInput.addEventListener(ev, function () {
          var dirtyFileds = 0;
          visibleInputs.forEach((input) => {
            if (!input.validity.valid) {
              if (input.closest("label")) {
                input.closest("label").classList.add("invalid");
              } else {
                input.classList.add("invalid");
              }
              dirtyFileds++;
              return false;
            } else {
              if (input.closest("label")) {
                input.closest("label").classList.remove("invalid");
              } else {
                input.classList.remove("invalid");
              }
            }

            if (visibleInputs[0].type == "checkbox") {
              var dirtyCheckboxes = document.querySelectorAll(".main__panel[style*='block'] input:not([name*='type']):checked").length;
              if (dirtyCheckboxes == 0) {
                dirtyFileds = 1;
              } else {
                dirtyFileds = 0;
              }
            }
          });
          if (dirtyFileds == 0) {
            document.querySelector(".main__panel[style*='block'] .button.primary").removeAttribute("disabled");
          } else {
            document.querySelector(".main__panel[style*='block'] .button.primary").setAttribute("disabled", "disabled");
          }
        });
      });
    });
  },
  initProductCarsousel: function (products) {
    if (Object.entries(products).length > 1) {
      document.querySelector(".main__plan-suggestions").classList.add("multiple");
      document.querySelector(".main").classList.add("multiple");
    } else {
      document.querySelector(".main__plan-suggestions").classList.remove("multiple");
      document.querySelector(".main").classList.remove("multiple");
    }
    document.querySelectorAll(".product-box").forEach((box) => {
      box.style.display = "none";
    });

     Object.entries(products).forEach(([key, value]) => {
      var handle = Handles[String(key)];
      var request = new XMLHttpRequest();
      var theProductBox = document.querySelector(".product-box." + String(key).toLowerCase());
      var sliderList = theProductBox.querySelector("#product-slider .splide__list");
      sliderList.innerHTML = "";

      request.open("GET", `/products/${handle}.js`, true);

      request.onload = function () {
        if (request.status >= 200 && request.status < 400) {
          // Success!
          var data = JSON.parse(request.responseText);
          var images = data.images;
          var imagesString = "";
          images.slice(0, 2).forEach((image) => {
            imagesString =
              imagesString +
              `<li class="splide__slide">
                <img class="product-cover-image"
                    src="${image}"></li>`;
          });
          sliderList.innerHTML = imagesString;
          theProductBox.style.display = "block";
          new Splide("." + String(key).toLowerCase() + " #product-slider", {
            type: "loop",
            perPage: 1,
            gap: 0,
            speed: 700,
            pagination: false,
            easing: "cubic-bezier(0.55, 0.24, 0.52, 1.0)",
            autoplay: false,
            interval: 600000,
            padding: 0,
            updateOnMove: true,
            pagination: true,
            arrows: true,
            arrowPath:
               "M1 4.65684C0.668629 4.65684 0.4 4.92547 0.4 5.25684C0.4 5.58821 0.668629 5.85684 1 5.85684V4.65684ZM28.4243 5.6811C28.6586 5.44679 28.6586 5.06689 28.4243 4.83257L24.6059 1.01419C24.3716 0.779881 23.9917 0.779881 23.7574 1.01419C23.523 1.24851 23.523 1.62841 23.7574 1.86272L27.1515 5.25684L23.7574 8.65095C23.523 8.88526 23.523 9.26516 23.7574 9.49948C23.9917 9.73379 24.3716 9.73379 24.6059 9.49948L28.4243 5.6811ZM1 5.85684H28V4.65684H1V5.85684Z",
       }).mount();
        } else {
          // We reached our target server, but it returned an error
        }
      };

      request.onerror = function () {
        // There was a connection error of some sort
      };

      request.send();
    }); 
  },
  handleEmpty: function () {
    return document.getElementById("name").value.length > 1;
  },
  initBreedSelection: function () {
    var breeds = [
      "Afador",
      "Afaird",
      "Affen Border Terrier",
      "Affen Spaniel",
      "Affen Tzu",
      "Affenchon",
      "Affengriffon",
      "Affenhuahua",
      "Affenpinscher",
      "Affenpoo",
      "Affenpug",
      "Affenshire",
      "Affenwich",
      "Afghan Chon",
      "Afghan Collie",
      "Afghan Hound",
      "Afghan Retriever",
      "Afghan Sheepdog",
      "Afghan Spaniel",
      "Afollie",
      "Airedale Shepherd",
      "Airedale Terrier",
      "Airedoodle",
      "Akbash",
      "Akbash Pyrenees",
      "Akbash Rottie",
      "Aki-poo",
      "Akita",
      "Akita Basset",
      "Akita Bernard",
      "Akita Chow",
      "Akita Pit",
      "Akita Shepherd",
      "Akitamatian",
      "Alaskan Goldenmute",
      "Alaskan Husky Shepherd",
      "Alaskan Irish Setsky",
      "Alaskan Klee Kai",
      "Alaskan Malador",
      "Alaskan Malamute",
      "Alaskan Pit Bull Terrier",
      "Alaskan Shepherd",
      "Alaskan Weimsky",
      "Alusky",
      "American Bandogge",
      "American Boston Bull Terrier",
      "American Boxer Foxhound",
      "American Bull-Aussie",
      "American Bull Dane",
      "American Bull Dogue De Bordeaux",
      "American Bull-Jack",
      "American Bull Pei",
      "American Bull Staffy",
      "American Bulldog",
      "American Bulldog Shepherd",
      "American Bullhuahua",
      "American Bullweiler",
      "American Chow Bulldog",
      "American Eagle Dog",
      "American English Coonhound",
      "American Eskimo Dog",
      "American Foxeagle",
      "American Foxhound",
      "American Foxy Dane",
      "American French Bull Terrier",
      "American Hairless Terrier",
      "American Lab Foxhound",
      "American Leopard Hound",
      "American Molossus",
      "American Pit Bull Terrier",
      "American Pit Corso",
      "American Pugabull",
      "American Rat Pinscher",
      "American Staffordshire Terrier",
      "American Water Spaniel",
      "Amstiff",
      "Anatolian Pyrenees",
      "Anatolian Shepherd Dog",
      "Appenzeller Sennenhunde",
      "Auggie",
      "Aussalier",
      "Aussie-Chi",
      "Aussie Rottie",
      "Aussie Shiba",
      "Aussiedoodle",
      "Aussiepom",
      "Australian Bernedoodle",
      "Australian Boxherd",
      "Australian Cattle Dog",
      "Australian Kelpie",
      "Australian Labradoodle",
      "Australian Retriever",
      "Australian Shepherd",
      "Australian Shepherd Husky",
      "Australian Shepherd Lab Mix",
      "Australian Shepherd Pit Bull Mix",
      "Australian Stumpy Tail Cattle Dog",
      "Australian Terrier",
      "Azawakh",
      "Ba-Shar",
      "Bagle Hound",
      "Barbado da Terceira",
      "Barbet",
      "Bascottie",
      "Basenji",
      "Bassador",
      "Basschshund",
      "Basset Bleu de Gascogne",
      "Basset Fauve de Bretagne",
      "Basset Hound",
      "Basset Jack",
      "Basset Retriever",
      "Bassetoodle",
      "Bavarian Mountain Scent Hound",
      "Bea-Tzu",
      "Beabull",
      "Beagle",
      "Beaglier",
      "Bearded Collie",
      "Bedlington Terrier",
      "Belgian Laekenois",
      "Belgian Malinois",
      "Belgian Sheepdog",
      "Belgian Tervuren",
      "Bergamasco Sheepdog",
      "Berger Picard",
      "Bernedoodle",
      "Bernese Mountain Dog",
      "Bichon Frise",
      "Bichonaranian",
      "Bidoodle",
      "Biewer Terrier",
      "Black and Tan Coonhound",
      "Black Mouth Cur",
      "Black Russian Terrier",
      "Bloodhound",
      "Blue Lacy",
      "Bluetick Coonhound",
      "Bocker",
      "Boerboel",
      "Boglen Terrier",
      "Bohemian Shepherd",
      "Bolognese",
      "Bolonoodle",
      "Borador",
      "Border-Aussie",
      "Border Collie",
      "Border Sheepdog",
      "Border Terrier",
      "Bordoodle",
      "Borzoi",
      "BoShih",
      "Bossie",
      "Boston Boxer",
      "Boston Terrier",
      "Boston Terrier Pekingese Mix",
      "Bouvier des Flandres",
      "Boxador",
      "Boxer",
      "Boxerdoodle",
      "Boxmatian",
      "Boxweiler",
      "Boykin Spaniel",
      "Bracco Italiano",
      "Braque du Bourbonnais",
      "Braque Francais Pyrenean",
      "Briard",
      "Brittany",
      "Broholmer",
      "Brusselranian",
      "Brussels Griffon",
      "Bugg",
      "Bull Arab",
      "Bull-Pei",
      "Bull Terrier",
      "Bullador",
      "Bullboxer Pit",
      "Bulldog",
      "Bullmastiff",
      "Bullmatian",
      "Cairn Terrier",
      "Cairnoodle",
      "Canaan Dog",
      "Cane Corso",
      "Cardigan Welsh Corgi",
      "Carolina Dog",
      "Catahoula Bulldog",
      "Catahoula Leopard Dog",
      "Caucasian Shepherd Dog",
      "Cav-a-Jack",
      "Cav-a-Malt",
      "Cava-Chin",
      "Cava Inu",
      "Cava-lon",
      "Cavachon",
      "Cavador",
      "Cavalier King Charles Spaniel",
      "Cavapom",
      "Cavapoo",
      "Central Asian Shepherd Dog",
      "Cesky Terrier",
      "Chabrador",
      "Cheagle",
      "Chesapeake Bay Retriever",
      "Chi Chi",
      "Chi-Poo",
      "Chigi",
      "Chihuahua",
      "Chilier",
      "Chinaranian",
      "Chinese Crested",
      "Chinese Shar-Pei",
      "Chinook",
      "Chion",
      "Chipin",
      "Chipoo",
      "Chiweenie",
      "Chorkie",
      "Chow Chow",
      "Chow Shepherd",
      "Chug",
      "Chusky",
      "Cirneco dell’Etna",
      "Clumber Spaniel",
      "Cockalier",
      "Cockapoo",
      "Cockapoochi",
      "Cocker Spaniel",
      "Cockeranian",
      "Collie",
      "Corgi Inu",
      "Corgidor",
      "Corgipoo",
      "Corkie",
      "Corman Shepherd",
      "Coton de Tulear",
      "Croatian Sheepdog",
      "Curly-Coated Retriever",
      "Czechoslovakian Vlcak",
      "Dachsador",
      "Dachshund",
      "Dalmatian",
      "Dameranian",
      "Dandie Dinmont Terrier",
      "Daniff",
      "Danish-Swedish Farmdog",
      "Deutscher Wachtelhund",
      "Doberdor",
      "Doberman Pinscher",
      "Docker",
      "Dogo Argentino",
      "Dogue de Bordeaux",
      "Dorgi",
      "Dorkie",
      "Doxiepoo",
      "Doxle",
      "Drentsche Patrijshond",
      "Drever",
      "Dutch Shepherd",
      "English Cocker Spaniel",
      "English Foxhound",
      "English Setter",
      "English Springer Spaniel",
      "English Toy Spaniel",
      "Entlebucher Mountain Dog",
      "Eskipoo",
      "Estrela Mountain Dog",
      "Eurasier",
      "Field Spaniel",
      "Fila Brasileiro",
      "Finnish Lapphund",
      "Finnish Spitz",
      "Flat-Coated Retriever",
      "Fox Terrier",
      "French Bulldog",
      "French Bullhuahua",
      "French Spaniel",
      "Frenchton",
      "Frengle",
      "German Longhaired Pointer",
      "German Pinscher",
      "German Shepherd Dog",
      "German Shepherd Pit Bull",
      "German Shepherd Rottweiler Mix",
      "German Sheprador",
      "German Shorthaired Pointer",
      "German Spitz",
      "German Wirehaired Pointer",
      "Giant Schnauzer",
      "Glen of Imaal Terrier",
      "Goberian",
      "Goldador",
      "Golden Cavalier",
      "Golden Cocker Retriever",
      "Golden Mountain Dog",
      "Golden Mountain Doodle",
      "Golden Retriever",
      "Golden Retriever Corgi",
      "Golden Shepherd",
      "Goldendoodle",
      "Gollie",
      "Gordon Setter",
      "Great Dane",
      "Great Pyrenees",
      "Greater Swiss Mountain Dog",
      "Greyador",
      "Greyhound",
      "Hamiltonstovare",
      "Hanoverian Scenthound",
      "Harrier",
      "Havanese",
      "Havapoo",
      "Hokkaido",
      "Horgi",
      "Hovawart",
      "Huskita",
      "Huskydoodle",
      "Ibizan Hound",
      "Icelandic Sheepdog",
      "Irish Red And White Setter",
      "Irish Setter",
      "Irish Terrier",
      "Irish Water Spaniel",
      "Irish Wolfhound",
      "Italian Greyhound",
      "Jack-A-Poo",
      "Jack Chi",
      "Jack Russell Terrier",
      "Jackabee",
      "Jackaranian",
      "Jackshund",
      "Jagdterrier",
      "Japanese Chin",
      "Japanese Spitz",
      "Korean Jindo Dog",
      "Kai Ken",
      "Kangal Shepherd Dog",
      "Karelian Bear Dog",
      "Keeshond",
      "Kerry Blue Terrier",
      "King Shepherd",
      "Kishu Ken",
      "Komondor",
      "Kooikerhondje",
      "Kromfohrlander",
      "Kuvasz",
      "Kyi-Leo",
      "La Pom",
      "Lab Pointer",
      "Labernese",
      "Labmaraner",
      "Labrabull",
      "Labradane",
      "Labradoodle",
      "Labrador Retriever",
      "Labrastaff",
      "Labsky",
      "Lagotto Romagnolo",
      "Lakeland Terrier",
      "Lancashire Heeler",
      "Lapponian Herder",
      "Leonberger",
      "Lhasa Apso",
      "Lhasapoo",
      "Lowchen",
      "Maltese",
      "Maltese Shih Tzu",
      "Maltipoo",
      "Manchester Terrier",
      "Maremma Sheepdog",
      "Mastador",
      "Mastiff",
      "Mauzer",
      "Meagle",
      "Miniature Pinscher",
      "Miniature Schnauzer",
      "Morkie",
      "Mountain Cur",
      "Mountain Feist",
      "Mudi",
      "Mutt (Mixed)",
      "Neapolitan Mastiff",
      "Newfoundland",
      "Newfypoo",
      "Norfolk Terrier",
      "Northern Inuit Dog",
      "Norwegian Buhund",
      "Norwegian Elkhound",
      "Norwegian Lundehund",
      "Norwich Terrier",
      "Nova Scotia Duck Tolling Retriever",
      "Old English Sheepdog",
      "Otterhound",
      "Papillon",
      "Papipoo",
      "Patterdale Terrier",
      "Peekapoo",
      "Pekalier",
      "Pekingese",
      "Pembroke Welsh Corgi",
      "Perro de Presa Canario",
      "Petit Basset Griffon Vendéen",
      "Pharaoh Hound",
      "Pitsky",
      "Plott",
      "Pocket Beagle",
      "Pointer",
      "Polish Lowland Sheepdog",
      "Pomanauze",
      "Pomapoo",
      "Pomchi",
      "Pomeagle",
      "Pomeranian",
      "Pomeranian Cockapoo",
      "Pomerdog",
      "Pomsky",
      "Poochon",
      "Poodle",
      "Poogle",
      "Porcelaine",
      "Porkie",
      "Portuguese Podengo Pequeno",
      "Portuguese Pointer",
      "Portuguese Sheepdog",
      "Portuguese Water Dog",
      "Pudelpointer",
      "Pug",
      "Pugalier",
      "Puggat",
      "Puggle",
      "Puginese",
      "Puli",
      "Pyredoodle",
      "Pyrenean Mastiff",
      "Pyrenean Shepherd",
      "Rafeiro do Alentejo",
      "Rat Terrier",
      "Redbone Coonhound",
      "Rhodesian Ridgeback",
      "Romanian Mioritic Shepherd Dog",
      "Rottador",
      "Rottle",
      "Rottweiler",
      "Russian Toy",
      "Russian Tsvetnaya Bolonka",
      "Saint Berdoodle",
      "Saint Bernard",
      "Saluki",
      "Samoyed",
      "Samusky",
      "Schapendoes",
      "Schipperke",
      "Schnocker",
      "Schnoodle",
      "Scoodle",
      "Scottish Deerhound",
      "Scottish Terrier",
      "Sealyham Terrier",
      "Segugio Italiano",
      "Sheepadoodle",
      "Shepadoodle",
      "Shepsky",
      "Shetland Sheepdog",
      "Shiba Inu",
      "Shichon",
      "Shih-Poo",
      "Shih Tzu",
      "Shikoku",
      "Shiloh Shepherd",
      "Shiranian",
      "Shollie",
      "Shorkie",
      "Siberian Husky",
      "Silken Windhound",
      "Silky Terrier",
      "Skye Terrier",
      "Sloughi",
      "Slovakian Wirehaired Pointer",
      "Slovensky Cuvac",
      "Slovensky Kopov",
      "Small Munsterlander Pointer",
      "Soft Coated Wheaten Terrier",
      "Spanish Mastiff",
      "Spanish Water Dog",
      "Spinone Italiano",
      "Springador",
      "Springerdoodle",
      "Stabyhoun",
      "Staffordshire Bull Terrier",
      "Staffy Bull Bullmastiff",
      "Standard Schnauzer",
      "Sussex Spaniel",
      "Swedish Lapphund",
      "Swedish Vallhund",
      "Taiwan Dog",
      "Terripoo",
      "Texas Heeler",
      "Thai Ridgeback",
      "Tibetan Mastiff",
      "Tibetan Spaniel",
      "Tibetan Terrier",
      "Tornjak",
      "Tosa",
      "Toy Fox Terrier",
      "Transylvanian Hound",
      "Treeing Tennessee Brindle",
      "Treeing Walker Coonhound",
      "Utonagan",
      "Valley Bulldog",
      "Vizsla",
      "Weimaraner",
      "Weimardoodle",
      "Welsh Springer Spaniel",
      "Welsh Terrier",
      "West Highland White Terrier",
      "Westiepoo",
      "Whippet",
      "Whoodle",
      "Wirehaired Pointing Griffon",
      "Working Kelpie",
      "Xoloitzcuintli",
      "Yakutian Laika",
      "Yorkipoo",
      "Yorkshire Terrier",
    ];
    function autocomplete(inp, arr) {
      /*the autocomplete function takes two arguments,
      the text field element and an array of possible autocompleted values:*/
      var currentFocus;
      /*execute a function when someone writes in the text field:*/
      inp.addEventListener("input", function (e) {
        var a,
          b,
          i,
          val = this.value;
        /*close any already open lists of autocompleted values*/
        closeAllLists();
        if (!val) {
          return false;
        }
        currentFocus = -1;
        /*create a DIV element that will contain the items (values):*/
        a = document.createElement("DIV");
        a.setAttribute("id", this.id + "autocomplete-list");
        a.setAttribute("class", "autocomplete-items");
        /*append the DIV element as a child of the autocomplete container:*/
        this.parentNode.appendChild(a);
        /*for each item in the array...*/
        for (i = 0; i < arr.length; i++) {
          /*check if the item starts with the same letters as the text field value:*/
          if (arr[i].substr(0, val.length).toUpperCase() == val.toUpperCase()) {
            /*create a DIV element for each matching element:*/
            b = document.createElement("DIV");
            /*make the matching letters bold:*/
            b.innerHTML = "<strong>" + arr[i].substr(0, val.length) + "</strong>";
            b.innerHTML += arr[i].substr(val.length);
            /*insert a input field that will hold the current array item's value:*/
            b.innerHTML += "<input type='hidden' value='" + arr[i] + "'>";
            /*execute a function when someone clicks on the item value (DIV element):*/
            b.addEventListener("click", function (e) {
              /*insert the value for the autocomplete text field:*/
              inp.value = this.getElementsByTagName("input")[0].value;
              /*close the list of autocompleted values,
                  (or any other open lists of autocompleted values:*/
              closeAllLists();
            });
            a.appendChild(b);
          }
        }
      });
      /*execute a function presses a key on the keyboard:*/
      inp.addEventListener("keydown", function (e) {
        var x = document.getElementById(this.id + "autocomplete-list");
        if (x) x = x.getElementsByTagName("div");
        if (e.keyCode == 40) {
          /*If the arrow DOWN key is pressed,
            increase the currentFocus variable:*/
          currentFocus++;
          /*and and make the current item more visible:*/
          addActive(x);
        } else if (e.keyCode == 38) {
          //up
          /*If the arrow UP key is pressed,
            decrease the currentFocus variable:*/
          currentFocus--;
          /*and and make the current item more visible:*/
          addActive(x);
        } else if (e.keyCode == 13) {
          /*If the ENTER key is pressed, prevent the form from being submitted,*/
          e.preventDefault();
          if (currentFocus > -1) {
            /*and simulate a click on the "active" item:*/
            if (x) x[currentFocus].click();
          }
        }
      });
      function addActive(x) {
        /*a function to classify an item as "active":*/
        if (!x) return false;
        /*start by removing the "active" class on all items:*/
        removeActive(x);
        if (currentFocus >= x.length) currentFocus = 0;
        if (currentFocus < 0) currentFocus = x.length - 1;
        /*add class "autocomplete-active":*/
        x[currentFocus].classList.add("autocomplete-active");
      }
      function removeActive(x) {
        /*a function to remove the "active" class from all autocomplete items:*/
        for (var i = 0; i < x.length; i++) {
          x[i].classList.remove("autocomplete-active");
        }
      }
      function closeAllLists(elmnt) {
        /*close all autocomplete lists in the document,
        except the one passed as an argument:*/
        var x = document.getElementsByClassName("autocomplete-items");
        for (var i = 0; i < x.length; i++) {
          if (elmnt != x[i] && elmnt != inp) {
            x[i].parentNode.removeChild(x[i]);
          }
        }
      }
      /*execute a function when someone clicks in the document:*/
      document.addEventListener("click", function (e) {
        closeAllLists(e.target);
      });
    }
    autocomplete(document.getElementById("breed"), breeds);
  },
  initPanels: function () {
    var panels = document.querySelectorAll(".main__panel"),
      footerLinks = document.querySelectorAll(".footer li"),
      backLink = document.querySelector("#link"),
      labels = document.querySelectorAll(".selection-group label, .input-group label"),
      nextButtons = document.querySelectorAll(".main__panel .button.primary");

    labels.forEach((label) => {
      label.addEventListener("change", function (e) {
        if (!this.classList.contains("active")) {
          this.classList.add("active");
        } else {
          this.classList.remove("active");
        }
      });
    });

    ["hashchange", "load"].forEach((ev) => {
      window.addEventListener(ev, function () {
        var currentHash = window.location.hash;
        var currentPage = Number(currentHash.split("-")[1]) || 1;
        document.body.dataset.activePage = currentPage;
        if (window.location.hash.length > 0 && currentPage > 0) {
          panels.forEach((panel) => {
            panel.style.display = "none";
          });
          footerLinks.forEach((link) => {
            link.classList.remove("active");
          });

          document.querySelector(currentHash).style.display = "block";
          PawfyQuiz.initDirtyInputs();

          if (currentPage > 2 && !PawfyQuiz.handleEmpty()) {
            // window.location.hash = "#step-1";
            // return false;
          }
          switch (currentPage) {
            case 1:
              break;
            case 2:
              break;
            case 3:
              break;
            case 4:
              PawfyQuiz.initGenders();
              break;
            case 5:
              PawfyQuiz.initBreedSelection();
              break;
            case 6:
              break;
            case 7:
              Grades = {
                probiotic: 0,
                skinCoat: 0,
                hipJoint: 0,
                calming: 0,
                painRelief: 0,
                eyeSupport: 0,
                multivitamin: 0,
                analGlands: 0,
                allergyImmune: 0,
              };
              PawfyQuiz.initSymptoms();
              PawfyQuiz.initDirtyInputs();
              break;
            case 8:
              PawfyQuiz.initNoneValues();
              break;
            case 9:
              PawfyQuiz.initNoneValues();
              PawfyQuiz.initSeparationAnxiety();
              break;
            case 10:
              PawfyQuiz.initAnimation();
              break;
            case 11:
              var sessionID = String(Date.now());
              PawfyQuiz.initTabs();
              PawfyQuiz.productQuantitySelectorsBind();
              PawfyQuiz.initLogic(sessionID);
              PawfyQuiz.initCTAs(sessionID);
              break;
            default:
          }
          if (currentPage > 1 && currentPage <= 10) {
            backLink.querySelector("span").innerText = "BACK";
            backLink.href = "#step-" + (currentPage - 1);
            if (currentPage < 10) {
            //  document.querySelector('[data-active-panel="' + currentPage + '"]').classList.add("active");
              document.querySelector(".mobile.exit").style.display = "none";
              document.querySelector(".mobile.back").style.display = "block";
            }
          } else {
            backLink.querySelector("span").innerText = "BACK TO SHOP";
            backLink.href = "https://pawfy.com/pages/shop";
            document.querySelector(".mobile.exit").style.display = "block";
            document.querySelector(".mobile.back").style.display = "none";
          }
        }
      });
    });
  },
  initAnimation: function () {
    document.getElementById("user-name3").innerText = document.getElementById("dogName").value;
    setTimeout(function () {
      window.location.hash = "#step-11";
    }, 3000);
  },
  initMedications: function () {
    var medicationsSelects = document.querySelectorAll('[name="medicated"]');
    medicationsSelects.forEach((select) => {
      select.addEventListener("change", function (e) {
        e.preventDefault();
        medicationsSelects.forEach((input) => {
          input.closest("label").classList.remove("active");
        });
      });
    });
  },
  initSeparationAnxiety: function () {
    var experts = document.querySelectorAll('[name="separation"]');
    experts.forEach((expert) => {
      expert.addEventListener("change", function (e) {
        e.preventDefault();
        experts.forEach((input) => {
          input.closest("label").classList.remove("active");
        });
      });
    });
  },
  initGenders: function () {
    var genderSelects = document.querySelectorAll('[name="gender"]');
    genderSelects.forEach((select) => {
      select.addEventListener("change", function (e) {
        e.preventDefault();
        genderSelects.forEach((input) => {
          input.closest("label").classList.remove("active");
        });
      });
    });
  },
  initTabs: function () {
    var productBoxes = document.querySelectorAll(".product-box");
    productBoxes.forEach((productBox) => {
      var selects = productBox.querySelectorAll(".product-box__tabs-selects a"),
        panels = productBox.querySelectorAll(".product-box__tabs-content > div");
      selects.forEach((select) => {
        select.addEventListener("click", function (e) {
          e.preventDefault();
          var tabId = select.dataset.tabId;
          selects.forEach((choice) => {
            choice.classList.remove("active");
          });
          select.classList.add("active");
          panels.forEach((panel) => {
            panel.style.display = "none";
          });
          productBox.querySelector("[data-panel-id='" + tabId + "']").style.display = "block";
          if (tabId == 4) {
            setTimeout(PawfyQuiz.initIngredientsSlider(productBox), 600);
          }
        });
      });
    });
  },
  initSymptoms: function () {
    var improvementsRadios = document.querySelectorAll('[name="improvements"]'),
      selectedImprovements = document.querySelectorAll('[name="improvements"]:checked'),
      symptomsRadios = document.querySelectorAll('[name="symptoms"]'),
      availableChoices = [];

    selectedImprovements.forEach((improvement) => {
      var improvement = improvement.id;
      var choices = Improvements[improvement];
      availableChoices = availableChoices.concat(choices);
    });
    document.getElementById("symptomGroup").innerHTML = ``;
    availableChoices.forEach((choice) => {
      if (typeof choice != "undefined") {
        const result = choice.replace(/([A-Z])/g, " $1");
        const finalResult = result.charAt(0).toUpperCase() + result.slice(1);

        var element = ` <label for="${choice}"><input name="symptoms" type="checkbox" id="${choice}" /> ${finalResult} </label>`;
        document.getElementById("symptomGroup").insertAdjacentHTML("beforeend", element);
      }
    });
    var labels = document.querySelectorAll("#symptomGroup label");

    labels.forEach((label) => {
      label.addEventListener("change", function (e) {
        if (!this.classList.contains("active")) {
          this.classList.add("active");
        } else {
          this.classList.remove("active");
        }
      });
    });
  },
  initNoneValues: function () {
    if (!PawfyQuiz.nonValuesSet) {
      console.log("initNoneValues");
      PawfyQuiz.nonValuesSet = true;
      var nonValues = document.querySelectorAll('input[value="none"]');
      function toggle() {
        if (this.closest(".input-group").classList.contains("none-selected")) {
          this.closest(".input-group").classList.remove("none-selected");
        } else {
          this.closest(".input-group").classList.add("none-selected");
        }
      }
      nonValues.forEach((nonValue) => {
        nonValue.removeEventListener("change", toggle, true);
        nonValue.addEventListener("change", toggle, true);
      });
    }
  },
  pickHighest: function (obj, num) {
    const requiredObj = {};
    if (num > Object.keys(obj).length) {
      return false;
    }
    Object.keys(obj)
      .sort((a, b) => obj[b] - obj[a])
      .forEach((key, ind) => {
        if (ind < num) {
          requiredObj[key] = obj[key];
        }
      });
    return requiredObj;
  },
  initLogic: function (sessionID) {
    var selectedSymptoms = document.querySelectorAll('[name="symptoms"]:checked'),
      selectedAllergies = document.querySelectorAll('[name="allergies"]:checked'),
      selectedImprovements = document.querySelectorAll('[name="improvements"]:checked'),
      ///takingMeds = document.querySelector('[name="medicated"]:checked'),
      separationAnxiety = document.querySelector('[name="separation"]:checked').id,
      symptomsString = "",
      allergiesString = "",
      improvementsString = "",
      dogName = document.getElementById("dogName"),
      email = document.getElementById("email"),
      surname = document.getElementById("surname"),
      age = document.getElementById("age").value,
      weight = document.getElementById("weight").value,
      breed = document.querySelectorAll("#breed-dontknow:checked").length == 1 ? "Not Sure" : document.getElementById("breed").value,
      name = document.getElementById("name");
    if (name.value.length < 2 || dogName.value.length < 2 || email.value.length < 2 || surname.value.length < 1) {
      document.querySelector("#step-11 h1").innerText = "Missing Data";
      document.querySelector("#step-11 p").innerText = "Please populate all of the required fields in order to generate the right suggestions for you";
      document.querySelector("#step-11 .main__plan-summary").style.display = "none";
      document.querySelector("#step-11 .both").style.display = "none";
      return false;
    }
    document.querySelector("#step-11 h1").innerHTML = `<img src="https://cdn.shopify.com/s/files/1/0506/0424/5166/files/plan.svg" />Plan for <span id="user-name"></span>`;
    document.querySelector("#step-11 p").innerHTML = `<span id="user-name1"></span>, here's an overview of what we recommend based on the answers provided`;

    document.querySelector("#step-11 .main__plan-summary").style.display = "flex";
    selectedSymptoms.forEach((symptom, idx, array) => {
      var symptom = symptom.id;
      var productGrades = Symptoms[symptom];
      for (const [key, value] of Object.entries(productGrades)) {
        Grades[key] = Number(Grades[key]) + Number(value);
      }
      var result = symptom.replace(/([A-Z])/g, " $1");
      var finalResult = result.charAt(0).toUpperCase() + result.slice(1);

      symptomsString = symptomsString + finalResult + (idx === array.length - 1 ? "" : ", ");
    });

    selectedAllergies.forEach((allergy, idx, array) => {
      allergy = allergy.id;
      var result = allergy.replace(/([A-Z])/g, " $1");
      var finalResult = result.charAt(0).toUpperCase() + result.slice(1);
      allergiesString = allergiesString + finalResult + (idx === array.length - 1 ? "" : ", ");
    });

    selectedImprovements.forEach((improvement, idx, array) => {
      improvement = improvement.id;
      var result = improvement.replace(/([A-Z])/g, " $1");
      var finalResult = result.charAt(0).toUpperCase() + result.slice(1);
      improvementsString = improvementsString + finalResult + (idx === array.length - 1 ? "" : ", ");
    });

    if (allergiesString.toLowerCase().indexOf("none") > -1) {
      allergiesString = "No Allergies";
    } else if (allergiesString.toLowerCase().indexOf("chicken") > -1) {
      delete Grades["calming"];
    }
    document.getElementById("user-age").innerText = age;
    document.getElementById("user-allergies").innerText = allergiesString;
    document.getElementById("user-name").innerText = dogName.value;
    document.getElementById("user-improvements").innerText = improvementsString;
    document.getElementById("user-name1").innerText = name.value;
    document.getElementById("user-name2").innerText = dogName.value;
    document.getElementById("user-breed").innerText = breed;

    var grade = 0,
      treshold = 2;
    Object.entries(Grades).forEach(([key, value]) => {
      grade = grade + Number(value);
    });
    if (grade > 0) {
      if (separationAnxiety == "yes") {
        Grades["calming"] = Number(Grades["calming"]) + treshold;
      }
      var top2 = PawfyQuiz.pickHighest(Grades, 2);
      var firstSuggestion = Number(Object.entries(top2)[0][1]),
        secondSuggestion = Number(Object.entries(top2)[1][1]);

      if (secondSuggestion == 0) {
        top2 = PawfyQuiz.pickHighest(Grades, 1);
      } else {
        top2 = PawfyQuiz.pickHighest(Grades, 2);
      }
      PawfyQuiz.initProductCarsousel(top2);
    } else {
      PawfyQuiz.handleNoResult();
    }

    PawfyQuiz.writeToDB(
      name.value + " " + surname.value,
      dogName.value,
      email.value,
      weight,
      age,
      //takingMeds.id,
      breed,
      symptomsString,
      allergiesString,
      separationAnxiety,
      PawfyQuiz.pickHighest(Grades, 2),
      sessionID,
      document.querySelector('[name="gender"]:checked').id
    );
  },
  writeToDB: function (name, dogName, email, weight, age, breed, symptoms, allergies, separationAnxiety, grades, sessionID, gender) {
    const checkQuery = firebase
      .firestore()
      .collection("users2025")
      .where("email", "==", email)
      .get()
      .then((snapshot) => {
        if (snapshot.docs.length == 0) {
          const query = firebase
            .firestore()
            .collection("users2025")
            .doc()
            .set({
              username: name,
              dogName: dogName,
              email: email,
              weight: weight,
              breed: breed,
              symptoms: symptoms,
              allergies: allergies,
              separationAnxiety: separationAnxiety,
              age: age,
              grades: JSON.stringify(grades),
              sessionID: sessionID,
              dateOfSubmission: String(new Date()),
              gender: gender,
            })
            .then(() => {
              console.log("Document successfully written!");
            })
            .catch((error) => {
              console.error("Error writing document: ", error);
            });
        } else {
          snapshot.docs.forEach((doc) => {
            var db = firebase.firestore();
            db.collection("users2025")
              .doc(doc.id)
              .update({
                username: name,
                dogName: dogName,
                email: email,
                weight: weight,
                breed: breed,
                symptoms: symptoms,
                allergies: allergies,
                separationAnxiety: separationAnxiety,
                age: age,
                grades: JSON.stringify(grades),
                sessionID: sessionID,
                dateOfSubmission: String(new Date()),
                gender: gender,
              })
              .then(() => {
                console.log("Document successfully updated!");
              })
              .catch((error) => {
                console.error("Error writing document: ", error);
              });
          });
        }
      });
  },
  handleNoResult: function () {
    document.querySelector("#step-11 h1").innerText = "No Results";
    document.querySelector("#step-11 p").innerHTML = `<span>
      Sorry, we have no appropriate results for you at the moment,
      but check back soon! This may be due to allergens or other
       dietary requirements you have selected.<br><br>Have any questions?<br><br><br>
       <a class="button primary" href="https://pawfy.com/pages/contact"><span>Contact Us </span></a>

       </span>`;
    document.querySelector("#step-11 .main__plan-summary").style.display = "none";
    document.querySelector("#step-11 .both").style.display = "none";
  },
  productQuantitySelectorsBind: function (js) {
    var dropElements = document.querySelectorAll("ul.product-atf__qty");
    dropElements.forEach((dropElement) => {
      var parent = dropElement.closest(".product-box");
      var types = parent.querySelectorAll('[name*="type"]'),
        quantities = parent.querySelectorAll('[name*="qty"]'),
        monthlySmall = parent.querySelector("small.monthly");

      for (var j = 0; j < quantities.length; j++) {
        quantities[j].addEventListener("click", function (ev) {
          var lis = this.closest("ul").querySelectorAll("li");
          for (var l = 0; l < lis.length; l++) {
            lis[l].classList.remove("come-first");
          }

          this.closest("li").classList.add("come-first");
          dropElement.classList.toggle("dropped");
        });
      }

      for (var j = 0; j < types.length; j++) {
        types[j].addEventListener("change", function () {
          var theClass = parent.querySelector('[name*="type"]:checked').value;
          dropElement.classList.remove("subsave", "ss", "otp");
          dropElement.classList.add(theClass);
          if (theClass == "ss") {
            monthlySmall.classList.add("active");
          } else {
            monthlySmall.classList.remove("active");
          }
        });
      }
    });
  },
  initCTAs: function (sessionID) {
    var addToCartButtons = document.querySelectorAll(".addToCart");
    var addBothToCartButton = document.querySelector(".addBothToCart");
    var sellingPlans = {
      39474579898542: 499220654, //probiotic
      39403685019822: 497811630, // sking and coat
      39403668078766: 497778862, // calming
      39403667325102: 499187886, // hip and Joint
      39403688296622: 499155118, //pain relief
      39475091898542: 530743470, // probiotic
      39475091177646: 530710702, // skin and coat
      39475059392686: 530677934, // calming
      39475072827566: 530645166, // hip and Joint
      39475084689582: 530612398, // pain relief
      43141744951470: 2076213422,
      43141757599918: 2076246190,
      43119155380398: 2076278958,
      43119330295982: 2076311726,
      43516552773806: 2164719790,
      43533318815918: 2164687022,
      43868109635758: 2422407342,
      43863228711086: 2422374574,
      44053690712238: 2582282414,
      44053697724590: 2582249646,
    };
    addToCartButtons.forEach((button) => {
      button.addEventListener("click", function (ev) {
        ev.preventDefault();
        var parent = button.closest(".product-box");
        var VARIANT_ID = parent.dataset.variant,
          QUANTITY = parent.querySelector("[name*='qty']:checked").value,
          isSub = parent.querySelector(`[name*="type"]:checked`).value == "subsave";
        if (!isSub) {
          window.location.href = `https://pawfy-com.myshopify.com/cart/${VARIANT_ID}:${QUANTITY}?discount=QUIZ10`;
        } else {
          window.location.href = `https://pawfy-com.myshopify.com/cart/clear?return_to=/cart/add?items[][id]=${VARIANT_ID}%26items[][quantity]=${QUANTITY}%26items[][selling_plan]=${sellingPlans[VARIANT_ID]}%26return_to=/checkout?discount=QUIZ10`;
        }
      });
    });
    addBothToCartButton.addEventListener("click", function (ev) {
      ev.preventDefault();
      var parents = document.querySelectorAll(".product-box[style*='block']");
      var url = "https://pawfy-com.myshopify.com/cart/clear?return_to=/cart/add?";
      parents.forEach((parent) => {
        var VARIANT_ID = parent.dataset.variant,
          QUANTITY = parent.querySelector("[name*='qty']:checked").value,
          isSub = parent.querySelector(`[name*="type"]:checked`).value == "subsave";
        if (!isSub) {
          url = url + `items[][id]=${VARIANT_ID}%26items[][quantity]=${QUANTITY}%26`;
        } else {
          url = url + `items[][id]=${VARIANT_ID}%26items[][quantity]=${QUANTITY}%26items[][selling_plan]=${sellingPlans[VARIANT_ID]}%26`;
        }
      });
      url = url + `return_to=/checkout?discount=QUIZ10`;
      window.location.href = url;
    });
  },

  initQtySelector: function () {
    // This is the main function where which pass two ref parameters of Parent element & Child element
    const scrollIntoView = (parent, child) => {
      const parentBounding = parent.getBoundingClientRect(),
        clientBounding = child.getBoundingClientRect();

      const parentBottom = parentBounding.bottom,
        parentTop = parentBounding.top,
        clientBottom = clientBounding.bottom + 80,
        clientTop = clientBounding.top;

      if (parentTop >= clientTop) {
        scrollTo(parent, -(parentTop - clientTop), 300);
      } else if (clientBottom > parentBottom) {
        scrollTo(parent, clientBottom - parentBottom, 300);
      }
    };
    function scrollTo(element, to, duration) {
      let start = element.scrollTop,
        currentTime = 0,
        increment = 20;

      let animateScroll = function () {
        currentTime += increment;

        let val = easeInOutQuad(currentTime, start, to, duration);
        element.scrollTop = val;

        if (currentTime < duration) {
          setTimeout(animateScroll, increment);
        }
      };

      animateScroll();
    }
    // Function for smooth scroll animation with the time duration
    function easeInOutQuad(time, startPos, endPos, duration) {
      time /= duration / 2;

      if (time < 1) return (endPos / 2) * time * time + startPos;
      time--;
      return (-endPos / 2) * (time * (time - 2) - 1) + startPos;
    }

    var parents = document.querySelectorAll(".selectors");
    document.querySelector(".chooseSeparately").addEventListener("click", function (ev) {
      ev.preventDefault();

      scrollIntoView(document.querySelector("#main"), document.querySelector(".product-box[style*='block'] a.addToCart.button.primary"));
      document.querySelector(".both i").style.display = "none";
      document.querySelector(".both .chooseSeparately").style.display = "none";
      setTimeout(function () {
        document.body.classList.toggle("choose-one");
      }, 400);
    });

    parents.forEach((parent) => {
      var dropElement = parent.querySelector(".pack-selector");
      var choices = parent.querySelectorAll("input.quantity");
      var types = parent.querySelectorAll('[name*="type"]');
      var quantityLis = parent.querySelectorAll(".pack-selector li");
      var random = Math.floor(Math.random() * 30);
      choices.forEach((choice, i) => {
        choice.name = "quantity" + random;
        if (i == 0) {
          choice.checked = true;
        }
      });

      for (var j = 0; j < types.length; j++) {
        types[j].addEventListener("click", function () {
          var lis = this.closest("ol").querySelectorAll("li");
          for (var l = 0; l < lis.length; l++) {
            lis[l].classList.remove("active");
          }

          this.closest("li").classList.add("active");
          dropElement.classList.remove("dropped");
          setTimeout(function () {
            var theClass = parent.querySelector('[name*="type"]:checked').value,
              //theChecked = document.querySelector('[name="choice"]:checked').value,
              theElement = parent.querySelector(".is-" + theClass + " input");
            for (var c = 0; c < quantityLis.length; c++) {
              quantityLis[c].style.display = "none";
              if (quantityLis[c].classList.contains("is-" + theClass)) {
                quantityLis[c].style.display = "block";
              }
            }

            dropElement.classList.remove("sub", "otp");
            dropElement.classList.add(theClass);
            if (theClass == "sub") {
              parent.querySelector("small.small-ships").classList.add("active");
              parent.querySelector("small.monthly").classList.add("active");
            } else {
              parent.querySelector("small.small-ships").classList.remove("active");
              parent.querySelector("small.monthly").classList.remove("active");
            }
            theElement.removeAttribute("checked");
            theElement.dataset.checked = false;
            theElement.dispatchEvent(new Event("change"));
          }, 200);
        });
      }

      for (var j = 0; j < choices.length; j++) {
        choices[j].addEventListener("click", function (ev) {
          parent.closest(".product-box").querySelector(".addToCart").removeAttribute("disabled");

          var lis = this.closest("ul").querySelectorAll("li");
          for (var l = 0; l < lis.length; l++) {
            lis[l].classList.remove("come-first");
          }
          this.closest("li").classList.add("come-first");
          dropElement.classList.toggle("dropped");
          // if (document.querySelectorAll(".come-first").length == 2) {
          //   document.querySelector(".addBothToCart").removeAttribute("disabled");
          // }
        });
      }
    });
  },
   initResponsiveMenu: function () {
    document.querySelector(".menu-toggle").addEventListener("click", function (ev) {
      ev.preventDefault();
      document.querySelector("header.header-1").classList.toggle("active");
      document.querySelector("header.header-1 ul").classList.toggle("active");
    });
  },
  initEditAnswers: function () {
    document.querySelector(".header__button").addEventListener("click", function (ev) {
      ev.preventDefault();
      document.querySelector("#step-7 a.button.primary").setAttribute("disabled", "disabled");
      Grades = {
        probiotic: 0,
        skinCoat: 0,
        hipJoint: 0,
        calming: 0,
        painRelief: 0,
        eyeSupport: 0,
        multivitamin: 0,
        analGlands: 0,
        allergyImmune: 0,
      };

      Symptoms = {
        jointStiffness: { probiotic: 0, skinCoat: 0, hipJoint: 2, calming: 0, painRelief: 1, eyeSupport: 0, multivitamin: 0, analGlands: 0, allergyImmune: 0 },
        arthritis: { probiotic: 0, skinCoat: 0, hipJoint: 2, calming: 0, painRelief: 1, eyeSupport: 0, multivitamin: 0, analGlands: 0, allergyImmune: 0 },
        jointWear: { probiotic: 0, skinCoat: 0, hipJoint: 2, calming: 0, painRelief: 1, eyeSupport: 0, multivitamin: 0, analGlands: 0, allergyImmune: 0 },
        limping: { probiotic: 0, skinCoat: 0, hipJoint: 2, calming: 0, painRelief: 1, eyeSupport: 0, multivitamin: 0, analGlands: 0, allergyImmune: 0 },
        postSurgeryPain: { probiotic: 0, skinCoat: 0, hipJoint: 1, calming: 0, painRelief: 2, eyeSupport: 0, multivitamin: 0, analGlands: 0, allergyImmune: 0 },
        constipation: { probiotic: 2, skinCoat: 0, hipJoint: 0, calming: 0, painRelief: 0, eyeSupport: 0, multivitamin: 0, analGlands: 0, allergyImmune: 0 },
        diarrhea: { probiotic: 2, skinCoat: 0, hipJoint: 0, calming: 0, painRelief: 0, eyeSupport: 0, multivitamin: 0, analGlands: 0, allergyImmune: 0 },
        cramps: { probiotic: 2, skinCoat: 0, hipJoint: 0, calming: 0, painRelief: 0, eyeSupport: 0, multivitamin: 2, analGlands: 0, allergyImmune: 0 },
        bloating: { probiotic: 2, skinCoat: 0, hipJoint: 0, calming: 0, painRelief: 0, eyeSupport: 0, multivitamin: 0, analGlands: 0, allergyImmune: 0 },
        upsetStomach: { probiotic: 2, skinCoat: 0, hipJoint: 0, calming: 0, painRelief: 0, eyeSupport: 0, multivitamin: 0, analGlands: 0, allergyImmune: 0 },
        worms: { probiotic: 1, skinCoat: 0, hipJoint: 0, calming: 0, painRelief: 0, eyeSupport: 0, multivitamin: 0, analGlands: 0, allergyImmune: 0 },
        parasites: { probiotic: 2, skinCoat: 0, hipJoint: 0, calming: 0, painRelief: 0, eyeSupport: 0, multivitamin: 0, analGlands: 0, allergyImmune: 0 },
        weakImmunity: { probiotic: 2, skinCoat: 0, hipJoint: 0, calming: 0, painRelief: 0, eyeSupport: 0, multivitamin: 2, analGlands: 0, allergyImmune: 0 },
        lowEnergy: { probiotic: 1, skinCoat: 0, hipJoint: 0, calming: 0, painRelief: 0, eyeSupport: 0, multivitamin: 0, analGlands: 0, allergyImmune: 0 },
        repeatInfections: { probiotic: 2, skinCoat: 0, hipJoint: 0, calming: 0, painRelief: 0, eyeSupport: 0, multivitamin: 2, analGlands: 0, allergyImmune: 0 },
        pawBiting: { probiotic: 2, skinCoat: 0, hipJoint: 0, calming: 0, painRelief: 0, eyeSupport: 0, multivitamin: 0, analGlands: 0, allergyImmune: 0 },
        itching: { probiotic: 1, skinCoat: 2, hipJoint: 0, calming: 0, painRelief: 0, eyeSupport: 0, multivitamin: 0, analGlands: 0, allergyImmune: 0 },
        poorFlexibility: { probiotic: 0, skinCoat: 0, hipJoint: 2, calming: 0, painRelief: 0, eyeSupport: 0, multivitamin: 0, analGlands: 0, allergyImmune: 0 },
        proneToInjury: { probiotic: 0, skinCoat: 0, hipJoint: 2, calming: 0, painRelief: 0, eyeSupport: 0, multivitamin: 2, analGlands: 0, allergyImmune: 0 },
        difficultyRunning: { probiotic: 0, skinCoat: 0, hipJoint: 2, calming: 0, painRelief: 0, eyeSupport: 0, multivitamin: 1, analGlands: 0, allergyImmune: 0 },
        stress: { probiotic: 0, skinCoat: 0, hipJoint: 0, calming: 2, painRelief: 0, eyeSupport: 0, multivitamin: 0, analGlands: 0, allergyImmune: 0 },
        anger: { probiotic: 0, skinCoat: 0, hipJoint: 0, calming: 2, painRelief: 0, eyeSupport: 0, multivitamin: 0, analGlands: 0, allergyImmune: 0 },
        anxiety: { probiotic: 0, skinCoat: 0, hipJoint: 0, calming: 2, painRelief: 0, eyeSupport: 0, multivitamin: 1, analGlands: 0, allergyImmune: 0 },
        tenseMuscles: { probiotic: 0, skinCoat: 0, hipJoint: 1, calming: 2, painRelief: 0, eyeSupport: 0, multivitamin: 0, analGlands: 0, allergyImmune: 0 },
        behaviouralProblems: { probiotic: 0, skinCoat: 0, hipJoint: 0, calming: 2, painRelief: 0, eyeSupport: 0, multivitamin: 0, analGlands: 0, allergyImmune: 0 },
        seasonalAllergies: { probiotic: 2, skinCoat: 2, hipJoint: 0, calming: 0, painRelief: 0, eyeSupport: 0, multivitamin: 0, analGlands: 0, allergyImmune: 0 },
        pawBiting: { probiotic: 2, skinCoat: 0, hipJoint: 0, calming: 0, painRelief: 0, eyeSupport: 0, multivitamin: 0, analGlands: 0, allergyImmune: 0 },
        excessiveLicking: { probiotic: 1, skinCoat: 2, hipJoint: 0, calming: 0, painRelief: 0, eyeSupport: 0, multivitamin: 0, analGlands: 0, allergyImmune: 0 },
        hairLoss: { probiotic: 0, skinCoat: 2, hipJoint: 0, calming: 0, painRelief: 0, eyeSupport: 0, multivitamin: 0, analGlands: 0, allergyImmune: 0 },
        hotSpots: { probiotic: 0, skinCoat: 2, hipJoint: 0, calming: 0, painRelief: 0, eyeSupport: 0, multivitamin: 0, analGlands: 0, allergyImmune: 0 },
        scabs: { probiotic: 0, skinCoat: 2, hipJoint: 0, calming: 0, painRelief: 0, eyeSupport: 0, multivitamin: 0, analGlands: 0, allergyImmune: 0 },
        bacterialInfection: { probiotic: 1, skinCoat: 2, hipJoint: 0, calming: 0, painRelief: 0, eyeSupport: 0, multivitamin: 0, analGlands: 0, allergyImmune: 0 },
        tearStains: { probiotic: 1, skinCoat: 0, hipJoint: 0, calming: 0, painRelief: 0, eyeSupport: 2, multivitamin: 0, analGlands: 0, allergyImmune: 0 },
        cataracts: { probiotic: 0, skinCoat: 0, hipJoint: 0, calming: 0, painRelief: 0, eyeSupport: 2, multivitamin: 1, analGlands: 0, allergyImmune: 0 },
        excessiveTearing: { probiotic: 0, skinCoat: 0, hipJoint: 0, calming: 0, painRelief: 0, eyeSupport: 2, multivitamin: 0, analGlands: 0, allergyImmune: 0 },
        visionLoss: { probiotic: 0, skinCoat: 0, hipJoint: 0, calming: 0, painRelief: 0, eyeSupport: 2, multivitamin: 0, analGlands: 0, allergyImmune: 0 },
        nightSight: { probiotic: 0, skinCoat: 0, hipJoint: 0, calming: 0, painRelief: 0, eyeSupport: 2, multivitamin: 0, analGlands: 0, allergyImmune: 0 },
        sleeplessness: { probiotic: 0, skinCoat: 0, hipJoint: 0, calming: 2, painRelief: 0, eyeSupport: 0, multivitamin: 0, analGlands: 0, allergyImmune: 0 },
        pain: { probiotic: 0, skinCoat: 0, hipJoint: 0, calming: 0, painRelief: 2, eyeSupport: 0, multivitamin: 0, analGlands: 0, allergyImmune: 0 },
        poorAgility: { probiotic: 0, skinCoat: 0, hipJoint: 2, calming: 0, painRelief: 0, eyeSupport: 0, multivitamin: 1, analGlands: 0, allergyImmune: 0 },
      };

      Improvements = {
        hips: ["jointStiffness", "arthritis", "jointWear", "limping", "postSurgeryPain"],
        gut: ["constipation", "diarrhea", "cramps", "bloating", "upsetStomach", "worms", "parasites"],
        immunity: ["weakImmunity", "lowEnergy", "repeatInfections", "pawBiting"],
        flexibility: ["poorFlexibility", "proneToInjury", "difficultyRunning"],
        anxietyIssues: ["stress", "anger", "anxiety", "tenseMuscles", "behaviouralProblems"],
        allergy: ["seasonalAllergies", "pawBiting", "excessiveLicking"],
        coat: ["hairLoss", "hotSpots", "scabs", "itching", "bacterialInfection"],
        vision: ["tearStains", "cataracts", "excessiveTearing", "visionLoss", "nightSight"],
        inflammation: ["sleeplessness", "pain", "poorAgility"],
      };
      window.location.hash = "#step-2";
    });
  },
};
PawfyQuiz.initEditAnswers();
PawfyQuiz.initPanels();
PawfyQuiz.initQtySelector();
PawfyQuiz.initResponsiveMenu();
